/**
 * @license
 * Copyright (c) %FIRST_YEAR% %CURRENT_YEAR%, Oracle and/or its affiliates.
 * Licensed under The Universal Permissive License (UPL), Version 1.0
 * as shown at https://oss.oracle.com/licenses/upl/
 * @ignore
 */

import { cssProps } from '@oracle/oraclejet-cssprops';

import { Divider } from '../UNSAFE_Divider';

const styles = {
  menuDividerContainer: cssProps`${{
    paddingTop: 'var(--oj-c-PRIVATE-DO-NOT-USE-menu-divider-vertical-padding)',
    paddingBottom: 'var(--oj-c-PRIVATE-DO-NOT-USE-menu-divider-vertical-padding)'
  }}`
};

export function MenuDivider() {
  return (
    <div class={styles.menuDividerContainer}>
      <Divider />
    </div>
  );
}
